import { render, staticRenderFns } from "./salesTreatment.vue?vue&type=template&id=66e57ba6&scoped=true"
import script from "./salesTreatment.vue?vue&type=script&lang=js"
export * from "./salesTreatment.vue?vue&type=script&lang=js"
import style0 from "./salesTreatment.vue?vue&type=style&index=0&id=66e57ba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e57ba6",
  null
  
)

export default component.exports